import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeftSmall = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={7} height={12} viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path d="M0 0h7v12H0z" /><path stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M5.757 1.757 1.515 6l4.242 4.243" /></g></svg>;
const ForwardRef = forwardRef(SvgArrowLeftSmall);
export { ForwardRef as ReactComponent };